import { API_URL } from '../../util/networkEndpoints';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { toServer } from '../../util/ServerSocket';
import './HYWorld.css';

export function HYWorld({ onClose }: { onClose: () => void }) {
  const [menuOpen,setMenuOpen]=useState(false);
  const root=useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    document.body.classList.add('hy-world-open');
    return () => document.body.classList.remove('hy-world-open');
  }, []);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    let active = true;
    const timeout = setTimeout(() => { if (active) setError('เชื่อมต่อ HY ไม่สำเร็จ กรุณากลับแล้วลองใหม่'); }, 15000);
    toServer('hyWorldEnter', {}, (result: { ok: boolean; ticket?: string; error?: string }) => {
      if (!active) return;
      clearTimeout(timeout);
      if (!result.ok || !result.ticket) { setError(result.error || 'ยังเข้าโลก HY ไม่ได้'); return; }
      const destination = new URL('/hy-world/play', API_URL);
      destination.hash = new URLSearchParams({ ticket: result.ticket, parentOrigin: window.location.origin }).toString();
      setUrl(destination.toString());
    });
    const receive = (event: MessageEvent) => {
      if (event.origin === new URL(API_URL as string).origin && event.data?.type === 'hy-world-close') close.current();
    };
    window.addEventListener('message', receive);
    return () => { active = false; clearTimeout(timeout); window.removeEventListener('message', receive); };
  }, []);
  return (
    <div className="hy-world" ref={root} role="dialog" aria-label="โลก HY">
      <button type="button" className="hy-world-menu-tab" aria-label="เมนู HY" aria-expanded={menuOpen} onClick={()=>setMenuOpen(!menuOpen)}>{menuOpen?'›':'‹'}</button>
      {menuOpen&&<nav className="hy-world-drawer" aria-label="เมนูเกม HY"><button type="button" onClick={onClose}>กลับหมู่บ้าน</button><button type="button" onClick={()=>{if(!document.fullscreenElement)root.current?.requestFullscreen?.().catch(()=>{});else document.exitFullscreen?.().catch(()=>{});}}>เต็มจอ</button><p>หมุนมือถือแนวนอนเพื่อเล่นเต็มพื้นที่<br/>กดเล็งเพื่อสลับเดิน/ปรับมุม<br/>กดค้างปุ่มยิงเพื่อสะสมแรง แล้วปล่อยยิง<br/>ลาก ⠿ เพื่อย้ายปุ่มควบคุม</p></nav>}
      {url ? <iframe title="เกม HY" src={url} allow="autoplay; fullscreen" /> :
        <div className="hy-world-status" role={error ? 'alert' : 'status'}>{error || 'กำลังย้ายไปโลก HY…'}</div>}
    </div>
  );
}
